import { ReactShellApi } from '../../../../../../src/components/layout/react-shell-type';

// set in /developer-tools
const CA_MA_MR_ID = localStorage.getItem('CA_MA_MR_ID');

export const mrPathSegment = location.pathname.split('/')[1];
export const isMR = Boolean(mrPathSegment.match(/^MR-[\d]*$/));

type Stage = 'local' | 'ent' | 'int' | 'test' | 'kon' | 'prod';

// get stage during runtime, because the existing build and deployment solution
// does not handle stage specific configs
function getStage(): Stage {
    if (process.env.BACKEND_STAGE) return process.env.BACKEND_STAGE as Stage;

    if (location.hostname === 'localhost') {
        return 'local';
    } else if (location.hostname === 'app.test.prisma-capacity.cloud') {
        return 'test';
    } else if (location.hostname === 'app.int.prisma-capacity.cloud') {
        return 'int';
    } else if (location.hostname === 'app.kon.prisma-capacity.cloud') {
        return 'kon';
    } else if (location.hostname === 'app.ent.prisma-capacity.cloud') {
        return 'ent';
    } else {
        return 'prod';
    }
}

const stage = getStage();

const local = {
    stage: 'local',
    appBaseUrl: 'http://localhost:4200',
    capacityManagement: CA_MA_MR_ID
        ? `https://capacity-management.ent.prisma-capacity.cloud/MR-${CA_MA_MR_ID}/`
        : 'https://capacity-management.ent.prisma-capacity.cloud/',
    contractManagement: 'https://contract-management.ent.prisma-capacity.cloud',
    organisationService:
        'https://organisation-service.ent.prisma-capacity.cloud',
    snamBidCollector21: 'https://snambidcollector21.ent.prisma-capacity.cloud',
    monolithBase: process.env.WITH_MONOLITH
        ? 'http://localhost:7070'
        : 'https://platform.ent.prisma-capacity.cloud',
    monolithApi: process.env.WITH_MONOLITH
        ? 'http://localhost:7070/rest'
        : 'https://platform.ent.prisma-capacity.cloud/rest',
    documentExchange: 'https://document-exchange.ent.prisma-capacity.cloud',
    gasDataManagement: 'https://gdm.ent.prisma-capacity.cloud',
    directFcfs: 'https://direct-fcfs.ent.prisma-capacity.cloud',
    regularFcfs: 'https://regular-fcfs.ent.prisma-capacity.cloud',
    remitReporting: 'https://remit-reporting.ent.prisma-capacity.cloud',
    lngOperators: [
        // joerg.adler+det@prisma-capacity.eu
        '1277952'
    ],
    authentication: {
        clientId: '50kaa2jg88i64p6kp3eb9f5qje',
        poolId: 'eu-central-1_exmWVAZhe'
    },
    iipService: 'https://iip-service.ent.prisma-capacity.cloud',
    ttpcModulationService:
        'https://ttpc-modulation-service.ent.prisma-capacity.cloud'
};
const ent = {
    stage: 'ent',
    appBaseUrl: 'https://app.ent.prisma-capacity.cloud',
    capacityManagement: CA_MA_MR_ID
        ? `https://capacity-management.ent.prisma-capacity.cloud/MR-${CA_MA_MR_ID}/`
        : 'https://capacity-management.ent.prisma-capacity.cloud/',
    contractManagement: 'https://contract-management.ent.prisma-capacity.cloud',
    organisationService:
        'https://organisation-service.ent.prisma-capacity.cloud',
    snamBidCollector21: 'https://snambidcollector21.ent.prisma-capacity.cloud',
    monolithBase: 'https://platform.ent.prisma-capacity.cloud',
    monolithApi: 'https://platform.ent.prisma-capacity.cloud/rest',
    documentExchange: 'https://document-exchange.ent.prisma-capacity.cloud',
    gasDataManagement: 'https://gdm.ent.prisma-capacity.cloud',
    directFcfs: 'https://direct-fcfs.ent.prisma-capacity.cloud',
    regularFcfs: 'https://regular-fcfs.ent.prisma-capacity.cloud',
    remitReporting: 'https://remit-reporting.ent.prisma-capacity.cloud',
    lngOperators: [
        // joerg.adler+det@prisma-capacity.eu
        '1277952'
    ],
    authentication: {
        clientId: '50kaa2jg88i64p6kp3eb9f5qje',
        poolId: 'eu-central-1_exmWVAZhe'
    },
    iipService: 'https://iip-service.ent.prisma-capacity.cloud',
    ttpcModulationService:
        'https://ttpc-modulation-service.ent.prisma-capacity.cloud'
};
const int = {
    stage: 'int',
    appBaseUrl: 'https://app.int.prisma-capacity.cloud',
    capacityManagement: 'https://capacity-management.int.prisma-capacity.cloud',
    contractManagement: 'https://contract-management.int.prisma-capacity.cloud',
    organisationService:
        'https://organisation-service.int.prisma-capacity.cloud',
    snamBidCollector21: 'https://snambidcollector21.int.prisma-capacity.cloud',
    monolithBase: 'https://platform.int.prisma-capacity.cloud',
    monolithApi: 'https://platform.int.prisma-capacity.cloud/rest',
    documentExchange: 'https://document-exchange.int.prisma-capacity.cloud',
    gasDataManagement: 'https://gdm.int.prisma-capacity.cloud',
    directFcfs: 'https://direct-fcfs.int.prisma-capacity.cloud',
    remitReporting: 'https://remit-reporting.int.prisma-capacity.cloud',
    regularFcfs: 'https://regular-fcfs.int.prisma-capacity.cloud',
    lngOperators: [],
    authentication: {
        clientId: '3665hjln7pldvhsel3s3aseh9k',
        poolId: 'eu-central-1_LJq12y9UE'
    },
    iipService: 'https://iip-service.int.prisma-capacity.cloud',
    ttpcModulationService:
        'https://ttpc-modulation-service.int.prisma-capacity.cloud'
};
const test = {
    stage: 'test',
    appBaseUrl: 'https://app.test.prisma-capacity.cloud',
    capacityManagement:
        'https://capacity-management.test.prisma-capacity.cloud',
    contractManagement:
        'https://contract-management.test.prisma-capacity.cloud',
    organisationService:
        'https://organisation-service.test.prisma-capacity.cloud',
    snamBidCollector21: 'https://snambidcollector21.test.prisma-capacity.cloud',
    monolithBase: 'https://platform.test.prisma-capacity.cloud',
    monolithApi: 'https://platform.test.prisma-capacity.cloud/rest',
    documentExchange: 'https://document-exchange.test.prisma-capacity.cloud',
    gasDataManagement: 'https://gdm.test.prisma-capacity.cloud',
    directFcfs: 'https://direct-fcfs.test.prisma-capacity.cloud',
    regularFcfs: 'https://regular-fcfs.test.prisma-capacity.cloud',
    remitReporting: 'https://remit-reporting.test.prisma-capacity.cloud',
    lngOperators: [
        // https://app.test.prisma-capacity.cloud/market-information/players/operators/ba3a158b-afa4-11ee-a890-023a9b972ba1
        '917548',
        // https://app.test.prisma-capacity.cloud/market-information/players/operators/22b53a92-afa9-11ee-a890-023a9b972ba1
        '917551',
        // https://app.test.prisma-capacity.cloud/market-information/players/operators/2ce47233-af99-11ee-a890-023a9b972ba1
        '917540',
        // https://app.test.prisma-capacity.cloud/market-information/players/operators/de1285f3-afa3-11ee-a890-023a9b972ba1
        '917545',
        // https://app.test.prisma-capacity.cloud/market-information/players/operators/0fd4334a-afaa-11ee-a890-023a9b972ba1
        '917553'
    ],
    authentication: {
        clientId: '3ivp6orah6s816h2vhefctlc58',
        poolId: 'eu-central-1_SyZiv5n2f'
    },
    iipService: 'https://iip-service.test.prisma-capacity.cloud',
    ttpcModulationService:
        'https://ttpc-modulation-service.test.prisma-capacity.cloud'
};
const kon = {
    stage: 'kon',
    appBaseUrl: 'https://app.kon.prisma-capacity.cloud',
    capacityManagement: 'https://capacity-management.kon.prisma-capacity.cloud',
    contractManagement: 'https://contract-management.kon.prisma-capacity.cloud',
    organisationService:
        'https://organisation-service.kon.prisma-capacity.cloud',
    snamBidCollector21: 'https://snambidcollector21.kon.prisma-capacity.cloud',
    monolithBase: 'https://platform.kon.prisma-capacity.cloud',
    monolithApi: 'https://platform.kon.prisma-capacity.cloud/rest',
    documentExchange: 'https://document-exchange.kon.prisma-capacity.cloud',
    gasDataManagement: 'https://gdm.kon.prisma-capacity.cloud',
    directFcfs: 'https://direct-fcfs.kon.prisma-capacity.cloud',
    regularFcfs: 'https://regular-fcfs.kon.prisma-capacity.cloud',
    remitReporting: 'https://remit-reporting.kon.prisma-capacity.cloud',
    lngOperators: [],
    authentication: {
        clientId: '1uv8rvcpbggt1flme3ttiufv5r',
        poolId: 'eu-central-1_sHx4WoQqt'
    },
    iipService: 'https://iip-service.kon.prisma-capacity.cloud',
    ttpcModulationService:
        'https://ttpc-modulation-service.kon.prisma-capacity.cloud'
};
const prod = {
    stage: 'prod',
    appBaseUrl: 'https://app.prisma-capacity.eu',
    capacityManagement:
        'https://capacity-management.prod.prisma-capacity.cloud',
    contractManagement:
        'https://contract-management.prod.prisma-capacity.cloud',
    organisationService:
        'https://organisation-service.prod.prisma-capacity.cloud',
    snamBidCollector21: 'https://snambidcollector21.prod.prisma-capacity.cloud',
    monolithBase: 'https://platform.prisma-capacity.eu',
    monolithApi: 'https://platform.prisma-capacity.eu/rest',
    documentExchange: 'https://document-exchange.prod.prisma-capacity.cloud',
    gasDataManagement: 'https://gdm.prod.prisma-capacity.cloud',
    directFcfs: 'https://direct-fcfs.prod.prisma-capacity.cloud',
    regularFcfs: 'https://regular-fcfs.prod.prisma-capacity.cloud',
    remitReporting: 'https://remit-reporting.prod.prisma-capacity.cloud',
    lngOperators: [
        // Fosmax LNG
        '196608',
        // Deutsche Energy Terminal GmbH
        '294912',
        // Elengy
        '327680',
        // TotalEnergies LNG Services France
        '360448',
        // Deutsche Regas Betriebs GmbH
        '393216'
    ],
    authentication: {
        clientId: '7imk7opbemjjk7t9fc0d3jdjvi',
        poolId: 'eu-central-1_5P3bKZaNn'
    },
    iipService: 'https://iip-service.prod.prisma-capacity.cloud',
    ttpcModulationService:
        'https://ttpc-modulation-service.prod.prisma-capacity.cloud'
};

function getConfig() {
    switch (stage) {
        case 'local':
            return local;
        case 'ent':
            if (isMR)
                ent.appBaseUrl = `https://app.ent.prisma-capacity.cloud/${mrPathSegment}`;
            return ent;
        case 'int':
            if (isMR)
                int.appBaseUrl = `https://app.int.prisma-capacity.cloud/${mrPathSegment}`;
            return int;
        case 'test':
            if (isMR)
                test.appBaseUrl = `https://app.test.prisma-capacity.cloud/${mrPathSegment}`;
            return test;
        case 'kon':
            if (isMR)
                kon.appBaseUrl = `https://app.kon.prisma-capacity.cloud/${mrPathSegment}`;
            return kon;
        case 'prod':
            return prod;
    }
}

const config = getConfig();

// a different stage was enforced for the backend, but we treat the stage config as 'local'
// as you only should do this for local development purposes
if (process.env.BACKEND_STAGE) {
    config.stage = 'local';
    config.appBaseUrl = 'http://localhost:4200';
}

export { config };

// note: during a transition period we allowed Angular to be opened outside of the React shell,
// but nowaways we always expect to be embedded in the React shell
export const embedded =
    window.parent !== window && window.name === 'embedded-angular';

if (!embedded)
    alert(
        'Ooops! You might have used an invalid deep link or query parameters that you cannot use. As a workaround, please replace "angular" with "platform" in the browser URL. If this error persists, please get in touch so we can find a solution together.'
    );

export const reactShell: ReactShellApi = (window.parent as any).reactShell;

export function showModalBackground() {
    window.parent.document.body.classList.add('angular-modal');
    document.body.classList.add('angular-modal');
}

export function hideModalBackground() {
    window.parent.document.body.classList.remove('angular-modal');
    document.body.classList.remove('angular-modal');
}
